import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { GenericBusinessCardStackBackgroundViewModel } from './generic-business-card-stack-background-view-model';
import type { GenericCardData } from '../../../../../../../models/print-cards/generic-card-data';

@Component({
  selector: 'app-generic-business-card-stack-background',
  templateUrl: './generic-business-card-stack-background.component.html',
  styleUrls: ['./generic-business-card-stack-background.component.scss'],
  providers: [GenericBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericBusinessCardStackBackgroundComponent extends CardBackgroundComponent implements AfterViewInit {
  constructor(
    public viewModel: GenericBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GenericCardData;
}
